import React, { useEffect, useState } from 'react';
import { Plus } from 'lucide-react';
import FlashCardMap from './FlashCardMap';
import { noteText } from '../utils/notePresentation';
import { t } from '../i18n';
import DetailPreviewPagination from './DetailPreviewPagination';
import CardFaceToggle from './CardFaceToggle';
import './NoteDetail.css';

const PREVIEW_PAGE_SIZE = 5;

export default function NoteCardList({ cards = [], personal = false, onAdd, onCardEdit, onCardReview, preview = false,
  title = noteText('cards'), description = '', paginationLabel = t('library.pagination') }) {
  const [page, setPage] = useState(1);
  const [showAnswersFirst, setShowAnswersFirst] = useState(false);
  const pageCount = preview ? Math.max(1, Math.ceil(cards.length / PREVIEW_PAGE_SIZE)) : 1;
  useEffect(() => setPage(1), [cards.length, preview]);
  const visibleCards = preview
    ? cards.slice((page - 1) * PREVIEW_PAGE_SIZE, page * PREVIEW_PAGE_SIZE)
    : cards;

  return (
    <section className="note-detail-cards">
      <header><div><h2>{title}</h2>{description && <p>{description}</p>}</div>{personal && <div className="note-detail-card-actions">
        <CardFaceToggle showAnswers={showAnswersFirst} onToggle={() => setShowAnswersFirst(value => !value)} disabled={!cards.length} />
        {onAdd && <button type="button" className="note-detail-button" onClick={onAdd}><Plus size={17} aria-hidden="true" />{noteText('addCard')}</button>}
      </div>}</header>
      <FlashCardMap flashCards={visibleCards} showAnswersFirst={showAnswersFirst} readOnly={!personal} showControls={personal} showProgress={personal} preserveOrder={!personal} onCardEdit={onCardEdit} onCardReview={onCardReview} />
      {preview && <DetailPreviewPagination page={page} pageCount={pageCount} onPageChange={setPage} ariaLabel={paginationLabel} />}
    </section>
  );
}
